module.exports = __webpack_public_path__ + "static/media/openbrix.fbfa01e7.png";